import React from 'react';
import AnnotionControll from '../components/Annotation/AnnotationControll';


const AnnotationPage = () => {
    return (
        <AnnotionControll />
    )
}
export default AnnotationPage